// New-order chime for the admin dashboard. Synthesized in-browser via the
// Web Audio API rather than an audio file, so there's no asset to host/
// upload/deploy — it just works everywhere the app already runs.
let ctx = null;
const getCtx = () => {
  if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
  return ctx;
};

// Browsers only allow an AudioContext to start/resume when that call
// happens synchronously inside a real user gesture (click/keydown) — a
// realtime Supabase callback (which is where playNewOrderChime actually
// gets called from, on a brand-new order) does not count, so resuming it
// only there leaves it permanently suspended and silently does nothing.
// AdminPage wires this up to fire once on the first click/keydown anywhere
// in the dashboard, which creates + unlocks the context ahead of time so
// the later, non-gesture resume() in playNewOrderChime is a no-op on an
// already-running context instead of the thing trying (and failing) to
// unlock it.
export function primeOrderSoundUnlock() {
  try {
    const audioCtx = getCtx();
    if (audioCtx.state === "suspended") audioCtx.resume();
  } catch {
    // Web Audio unsupported — nothing to unlock.
  }
}

function tone(audioCtx, freq, startAt, duration) {
  const osc = audioCtx.createOscillator();
  const gain = audioCtx.createGain();
  osc.type = "sine";
  osc.frequency.value = freq;
  gain.gain.setValueAtTime(0, startAt);
  gain.gain.linearRampToValueAtTime(0.25, startAt + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.001, startAt + duration);
  osc.connect(gain);
  gain.connect(audioCtx.destination);
  osc.start(startAt);
  osc.stop(startAt + duration);
}

export function playNewOrderChime() {
  try {
    const audioCtx = getCtx();
    if (audioCtx.state === "suspended") audioCtx.resume();
    const now = audioCtx.currentTime;
    tone(audioCtx, 880, now, 0.35);       // A5
    tone(audioCtx, 1108.73, now + 0.15, 0.4); // C#6 — bright two-note "ding-ding"
  } catch {
    // Web Audio unsupported/blocked by the browser — the sound is a
    // nicety on top of the existing visual popup, not worth surfacing.
  }
}

const MUTE_KEY = "admin_order_sound_muted";
export const isOrderSoundMuted = () => localStorage.getItem(MUTE_KEY) === "1";
export const setOrderSoundMuted = (muted) => localStorage.setItem(MUTE_KEY, muted ? "1" : "0");
